import { SearchService } from './search/search.service';

export const services = [SearchService];

export * from './search/search.service';
